import {
  firstName,
  middleName,
  lastName,
  email,
  emailConfirm,
  phoneType,
  recaptchaChallengeToken,
} from '@mgo/core/src/validations/person';
import { phoneNumber } from '../../utils/contactPhoneNumber';

import {
  oldStreetAddress,
  oldCity,
  oldState,
  oldZipCode,
  oldPoBoxNumber,
  oldUrbanizationName,
  newStreetAddress,
  newCity,
  newState,
  newZipCode,
  newPoBoxNumber,
  newPrivateMailbox,
  newUrbanizationName,
} from '@mgo/core/src/validations/address';

import {
  startDate,
  stopDate,
  moverType,
  forwardType,
  familySameLastName,
  familyRemaining,
  businessWholeCompany,
  businessName,
  businessAlias1,
  businessAlias2,
  businessAlias3,
  businessAlias4,
} from '@mgo/core/src/validations/coa';

export default {
  firstName,
  middleName,
  lastName,
  email,
  emailConfirm,
  phoneNumber,
  phoneType,
  oldStreetAddress,
  oldCity,
  oldState,
  oldZipCode,
  oldPoBoxNumber,
  oldUrbanizationName,
  newStreetAddress,
  newCity,
  newState,
  newZipCode,
  newPoBoxNumber,
  newPrivateMailbox,
  newUrbanizationName,
  startDate,
  stopDate,
  moverType,
  forwardType,
  familySameLastName,
  familyRemaining,
  businessWholeCompany,
  businessName,
  businessAlias1,
  businessAlias2,
  businessAlias3,
  businessAlias4,
  recaptchaChallengeToken,
};
